import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
import PublisherList from "./PublisherList";
import PublisherEdit from "./PublisherEdit";
import PublisherCreate from "./PublisherCreate";
import PublisherClose from "./PublisherClose";
function Publishers() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return React.createElement(PublisherList, null); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/approval/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherEdit, { status: "APPROVE" }))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherCreate, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherEdit, { status: "EDIT" }))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/close/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER, RoleEnum.PUBLISHER_ADMIN] },
                React.createElement(PublisherClose, { internalNote: "" }))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/restore/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherEdit, { status: "RESTORE" }))); } })));
}
export default Publishers;
